<template>
  <div>
    <div class="relative overflow-x-auto shadow-md sm:rounded-sm mt-5">
      <table class="w-full text-left rtl:text-right text-gray-700">
        <thead>
          <tr class="bg-gray-100 leading-normal">
            <th scope="col" class="py-3 px-6">
            <div class="flex items-center">
              #
            </div>
            </th>
            <th scope="col" class="py-3 px-6">
              <div class="flex items-center">
                Visit Code
              </div>
            </th>
            <th scope="col" class="py-3 px-6">
              <div class="flex items-center">
                Patient Unique Code
              </div>
            </th>
            <th scope="col" class="py-3 px-6">
              <div class="flex items-center">
                Patient Name
              </div>
            </th>
            <th scope="col" class="py-3 px-6">
              <div class="flex items-center">
                Requesting Doctor
              </div>
            </th>
            <th scope="col" class="py-3 px-6">
              <div class="flex items-center">
                Request Date/Time
              </div>
            </th>
            <th scope="col" class="py-3 px-6">
              <div class="flex items-center">
                Imaging Requested
              </div>
            </th>
            <th scope="col" class="py-3 px-6">
              <div class="flex items-center">
                Priority
              </div>
            </th>
<!--            <th scope="col" class="py-3 px-6">-->
<!--              <div class="flex items-center">-->
<!--                Status-->
<!--              </div>-->
<!--            </th>-->
            <th scope="col" class="py-3 px-6">Action</th>
          </tr>
        </thead>
        <tbody class="text-gray-600 text-md font-light">
          <tr v-for="(data, index) in radiologyTests" :key="index" class="border-b border-gray-200 hover:bg-gray-100">
            <td class="py-3 px-6 text-left whitespace-nowrap">{{ index + 1 }}</td>
            <td class="py-3 px-6 text-left whitespace-nowrap">{{ data.VisitCode }}</td>
            <td class="py-3 px-6 text-left whitespace-nowrap">{{ data.patient?.unique_code }}</td>
            <td class="py-3 px-6 text-left">{{ data.patient.FullName }}</td>
            <td class="py-3 px-6 text-left">{{ data.radiology_tests[0].requested_by?.Username }}</td>
            <td class="py-3 px-6 text-left">{{ formatDate(data.radiology_tests[0].created_at) }}</td>
            <td class="py-3 px-6 text-left">{{ fomartTests(data.radiology_tests) }}</td>
            <td class="py-3 px-6 text-left">
              <span
                  :class="getPriorityClass(getHighestPriority(data.radiology_tests))"
                  class="px-2 py-1 rounded-full text-xs"
              >
                {{ getHighestPriority(data.radiology_tests) }}
              </span>
            </td>
<!--            <td class="py-3 px-6 text-left">-->
<!--              <span :class="getStatusClass(data.status)" class="px-2 py-1 rounded-full text-xs">-->
<!--                {{ data.status }}-->
<!--              </span>-->
<!--            </td>-->
            <td class="py-3 px-6 text-left">
              <button @click="viewRadiologyRequest(data.VisitId)" class="bg-custom-yellow hover:bg-orange-600 text-white font-bold py-1 px-3 rounded">
                View
              </button>
            </td>
          </tr>
        </tbody>

      </table>
    </div>

    <PaginationComponent
        v-model:currentPage="currentPage"
        v-model:itemsPerPage="itemsPerPage"
        :totalPages="totalPages"
        :totalItems="totalItems"
        @update:currentPage="goToPage"
        @update:changePageSize="changePageSize"
    />

    <ConsultationPatientQueueModal :show="showConsultationModal" :patientId="selectedPatientId"
      @close="closeConsultationModal" @submit="handleAppointmentSubmit" />
  </div>
</template>
<script>
//   import CustomButton from "@/components/CustomButton.vue";
import ConsultationPatientQueueModal from "@/views/modals/ConsultationPatientQueueModal.vue";
import apiClient from "@/services/api";
import PaginationComponent from "@/components/shared/pagination.vue";

export default {
  name: "ReceptionPatientQueueTab",
  components: {
    PaginationComponent,
    //   CustomButton,
    ConsultationPatientQueueModal,
  },
  mounted() {
    this.getPatientRadiologyTests();
  },
  props: {
    searchQuery: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showConsultationModal: false,
      selectedPatientId: null,
      radiologyTests: [],
      pageSizes: [25, 50, 100],
      currentPage: 1,
      showLoader: false,
      totalItems: 0, // New: Total items from backend
      totalPages: 0, // New: Total pages from backend
    };
  },
  computed: {
    getTriageColor() {
      return (triageCode) => {
        switch (triageCode) {
          case 'Below 8':
            return 'bg-red-500';
          case '9-13':
            return 'bg-custom-yellow';
          case '14':
            return 'bg-yellow-200';
          case '15':
            return 'bg-green-500';
          case 'Code Blue':
            return 'bg-blue-500';
          default:
            return '';
        }
      };
    },
  },
  methods: {
    goToPage(pageNumber) {
      console.log("goToPage", pageNumber);
      this.getPatientRadiologyTests();
      this.currentPage = pageNumber;
    },
    formatDate(dateString) {
      const options = {
        // "Monday"
        year: "numeric", // "2025"
        month: "long", // "January"
        day: "numeric", // "22"
        hour: "numeric", // "1 PM"
        minute: "numeric", // "43"
        hour12: true, // 12-hour time format
      };
      const date = new Date(dateString);
      return date.toLocaleString("en-US", options);
    },
    sortedVisits(visits) {
      return visits.slice().sort((a, b) => {
        const priorityA = this.getHighestPriority(a.radiology_tests);
        const priorityB = this.getHighestPriority(b.radiology_tests);

        // Define priority order
        const priorityOrder = { STAT: 1, Urgent: 2, Normal: 3 };

        // return priorityOrder[priorityA] - priorityOrder[priorityB];
        const priorityDiff = priorityOrder[priorityA] - priorityOrder[priorityB];

        // If priorities differ, sort by priority
        if (priorityDiff !== 0) {
          return priorityDiff;
        }

        // If both are Normal (or same priority), sort by VisitStartTime
        return new Date(b.VisitStartTime) - new Date(a.VisitStartTime);
      });
    },
    getHighestPriority(labTests) {
      const priorities = labTests.map((test) => test.queue_priority);
      if (priorities.includes("STAT")) return "STAT";
      if (priorities.includes("Urgent")) return "Urgent";
      return "Normal";
    },
    async getPatientRadiologyTests() {
      try {
        this.showLoader = true;
        const response = await apiClient.listPatientRadiologyTests({
          page: this.currentPage,
          per_page: this.itemsPerPage,
        });
        if (response.success) {
          this.radiologyTests = this.sortedVisits(response.data);
          this.totalItems = response.meta.total_items; // Assuming meta data from backend
          this.totalPages = response.meta.total_pages; // Assuming meta data from backend
          this.itemsPerPage = response.meta.per_page;
          this.showLoader = false;
          // this.$toast.success("Facility services fetched successfully");
        } else {
          this.showLoader = false;
          this.$toast.error("Failed to fetch patient lab tests");
        }
      } catch (error) {
        this.showLoader = false;
        this.$toast.error("Failed to fetch patient lab tests");
      }
    },
    fomartTests(tests) {
      const testNames = tests.map((test) => test.imaging_type.name).join(", ");
      return testNames;
    },
    getPriorityClass(priority) {
      switch (priority) {
        case 'STAT': return 'bg-red-100 text-red-800';
        case 'Urgent': return 'bg-yellow-100 text-yellow-800';
        default: return 'bg-green-100 text-green-800';
      }
    },
    getStatusClass(status) {
      switch (status) {
        case 'New': return 'bg-blue-100 text-blue-800';
        case 'In progress': return 'bg-yellow-100 text-yellow-800';
        case 'Completed': return 'bg-green-100 text-green-800';
        case 'Rejected': return 'bg-red-100 text-red-800';
        default: return 'bg-gray-100 text-gray-800';
      }
    },
    viewRadiologyRequest(id) {
      this.$router.push({ name: 'RadiologyRequestDetails', params: { radiology_request_id: id } });
    }
  },
};
</script>

<style lang="css" scoped></style>